// extracted by mini-css-extract-plugin
export var changeIcon = "_49-4";
export var container = "_49-0";
export var divider = "_49-7";
export var externalLinkIcon = "_49-1";
export var green = "_49-5";
export var helpCircleIcon = "_49-3";
export var iconButton = "_49-2";
export var red = "_49-6";